<template>
  <router-view></router-view>
  <notifications :position="notificationPosition" />
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "app",
  async beforeCreate() {
    const token = await window.localStorage.getItem("token");
    this.$store.dispatch("setToken", token);
  },

  async created() {
  },

  async mounted() {
  },
  computed: {
    ...mapGetters(["getSatellite", "getKiosk"]),
    notificationPosition() {
      if (this.getSatellite || this.getKiosk) {
        return "bottom left";
      } else {
        return "bottom right";
      }
    },
  },
};
</script>

<style lang="scss">
@use "@monolith/styles";

.vue-notification-group {
  z-index: 11111111 !important;
  width: 350px !important;
  .vue-notification {
    font-size: 24px;
    color: var(--banner-colour);
  }

}
body {
  margin: 0px;
  padding: 0px;
  font-family: "Lato";
  color: var(--text-colour);
  background-color: var(--primary-colour);
}

form {
  font-size: 1em;
  label {
    display: block;
    font-size: 0.8em;
    font-weight: bold;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }
  input[type="text"],
  input[type="file"],
  input[type="number"],
  input[type="tel"],
  input[type="email"],
  input[type="password"],
  textarea {
    padding: 0.7rem;
    border-radius: 0.3rem;
    border: 1px solid #ccc;
    margin-bottom: 0.5rem;
    width: calc(100% - 2rem);
  }
}

button {
  padding: 1rem;
  border-radius: 0.3rem;
  border: 1px solid #ccc;
  background-color: var(--action-colour);
  font-size: 1rem;
  color: var(--secondary-text-colour);
  font-family: "Lato";
  margin: 0 1rem;
  display: inline-block !important;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
}

button.primary {
  background-color: var(--action-colour) !important;
}

button.persist {
  background-color: #65da3b !important;
}

button.warning {
  background-color: #ff9700 !important;
}

button.danger {
  background-color: #ff003b !important;
}

button.action {
  padding: 0.7rem;
  border-radius: 0.3rem;
  border: 1px solid #ccc;
  background-color: #ddd;
  margin: 0.5rem;
  width: 200px;
  display: inline-block !important;
}

.ql-container {
  background-color: var(--primary-colour);
}
.ql-toolbar {
  background-color: var(--secondary-text-colour);
}
</style>
